import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6dd2d019")
const _hoisted_1 = { id: "join" }
const _hoisted_2 = { class: "_header" }
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Join ", -1)
const _hoisted_5 = {
  key: 0,
  class: "_loadPrompt"
}
const _hoisted_6 = {
  key: 1,
  class: "_main"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "_subheader" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = {
  key: 0,
  class: "input user"
}
const _hoisted_15 = { class: "input" }
const _hoisted_16 = { class: "action" }
const _hoisted_17 = {
  key: 0,
  class: "searching"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Searching...", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "game_details"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", null, "You found a game!", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "When you're ready, click it to join the fun", -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_26 = {
  key: 1,
  class: "disclaimer"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h4", null, "Advisory", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "You have instructed us not to save cookies to your device. Accordingly, refreshes will disconnect you from games. Refresh your browser to turn on cookies.", -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 2,
  class: "disclaimer"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("By clicking the game card above, you agree to our ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("terms of service")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"tutorial\" data-v-6dd2d019><div class=\"confusedGraphic _img\" data-v-6dd2d019></div><div class=\"_c\" data-v-6dd2d019></div><h4 data-v-6dd2d019>How this works</h4><div class=\"_a\" data-v-6dd2d019></div><p data-v-6dd2d019>Another player hosts a game by browsing for one. Once a lobby is opened, a unique lobby code can be shared to you.</p><div class=\"_a\" data-v-6dd2d019></div><p data-v-6dd2d019>Type in this lobby code to the textbox above, and if it matches, the game will become visible - click this to join!</p></div>", 1)
const _hoisted_35 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_HistoryPopup = _resolveComponent("HistoryPopup")!
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!
  const _component_GamePreview = _resolveComponent("GamePreview")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconButton, {
          icon: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'}))),
          white: true
        })
      ]),
      _hoisted_4
    ]),
    _createVNode(_component_HistoryPopup),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_LoadSpinner, { text: "Loading" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.$store.state.Auth.user.unset == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.$store.state.Auth.user.name)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_9, "Hi, " + _toDisplayString(_ctx.$store.state.Auth.user.name) + "!", 1))
                    : (_openBlock(), _createElementBlock("h3", _hoisted_10, "Hi there!")),
                  (!_ctx.game)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Let's find a game to join"))
                    : (_ctx.searching)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Searching for a game"))
                      : (_openBlock(), _createElementBlock("p", _hoisted_13, "You've found a game, set your name and click it to join!"))
                ]),
                (!_ctx.$store.state.Auth.user.email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_TextInput, {
                        label: "Nickname",
                        default: _ctx.$store.state.Auth.user.name,
                        placeholder: "Your name",
                        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateName($event)))
                      }, null, 8, ["default"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_TextInput, {
                    label: "Lobby code",
                    default: _ctx.$store.state.GameView.lobby?.meta?.code,
                    placeholder: "5-character code",
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search($event)))
                  }, null, 8, ["default"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  (!_ctx.game)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_ctx.searching)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_18,
                              _createVNode(_component_MovingIcon, {
                                name: "loader_dots",
                                autoplay: true,
                                loop: true
                              }),
                              _hoisted_19,
                              _hoisted_20
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.game)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", null, [
                          _hoisted_22,
                          _hoisted_23,
                          (!_ctx.$store.state.Auth.user.name)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, "You have to set your name first."))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_25,
                        _createElementVNode("div", {
                          class: _normalizeClass({gameWrapper:true, waiting:!_ctx.$store.state.Auth.user.name})
                        }, [
                          _createVNode(_component_GamePreview, {
                            game: _ctx.game,
                            onClick: _ctx.openGame
                          }, null, 8, ["game", "onClick"])
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.$store.state.Utils.cookies)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
                  : _createCommentVNode("", true),
                (_ctx.game)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("p", null, [
                        _hoisted_31,
                        _createVNode(_component_router_link, { to: "privacy/terms" }, {
                          default: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 1
                        }),
                        _hoisted_33
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_34
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_MovingIcon, {
                  name: "loader_spinner",
                  autoplay: true,
                  loop: true
                })
              ]))
        ]))
  ]))
}